import { render, staticRenderFns } from "./collaborativeManagement.vue?vue&type=template&id=676432dc&scoped=true"
import script from "./collaborativeManagement.vue?vue&type=script&lang=js"
export * from "./collaborativeManagement.vue?vue&type=script&lang=js"
import style0 from "./collaborativeManagement.vue?vue&type=style&index=0&id=676432dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676432dc",
  null
  
)

export default component.exports